/* Copyright 2021, Milkdown by Mirone. */
import { stackOverFlow } from '@milkdown/exception';
export const getStackUtil = () => {
    const size = (ctx) => ctx.elements.length;
    const top = (ctx) => ctx.elements[size(ctx) - 1];
    const push = (ctx) => (node) => {
        var _a;
        (_a = top(ctx)) === null || _a === void 0 ? void 0 : _a.push(node);
    };
    const open = (ctx) => (node) => {
        ctx.elements.push(node);
    };
    const close = (ctx) => {
        const el = ctx.elements.pop();
        if (!el)
            throw stackOverFlow();
        return el;
    };
    return {
        size,
        top,
        push,
        open,
        close,
    };
};
//# sourceMappingURL=stack.js.map